module.exports = __webpack_public_path__ + "static/faq-banner-6fe9c00f9aff6aa4040a6a4ee33b8e27.jpg";